import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { DashboardProvider } from '../../../services';
import { AppFilter } from '@app/shared/models';
@Component({
	selector: 'app-dashboard-invoice',
	templateUrl: './dashboard-invoice.component.html',
	styleUrls: [ './dashboard-invoice.component.scss' ]
})
export class DashboardInvoiceComponent implements OnInit {
	form: FormGroup;
	pending: any;
	public mode: DatepickerMode = 'date';
	public dateClass = 'monthly';
	filter;
	fromDateString = '';
	toDateString = '';
	selectedType: string = 'all';
	error: string;
	customerNccId: any;
	currency: string = '₦';
	currencyId: any = 'naira';
	currencies: any;
	invoiceDetail;
	isAll: boolean = true;
	showAll: boolean = true;
	constructor(private fb: FormBuilder, private dashboardSvc: DashboardProvider) {
		this.filter = new AppFilter();
		this.form = fb.group({
			from: [],
			to: [],
			type: [ '' ]
		});
		let start = new Date();
		let end = new Date();
		start.setDate(start.getDate() - 7);
		this.form.patchValue({
			from: start,
			to: end
		});

		this.form.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((searchText) => {
			// console.log(searchText);
		});
		this.customerNccId = JSON.parse(window.localStorage.getItem('organization'))['jpaContractor']['nccId'];
		this.getRegistrationStatis();
		this.getCurrencies();
	}

	dateFilter(type) {
		switch (type) {
			case 'all':
				this.mode = 'date';
				this.dateClass = 'daily';
				break;
			case 'daily':
				this.mode = 'date';
				this.dateClass = 'daily';
				break;
			case 'monthly':
				this.mode = 'month';
				this.dateClass = 'monthly';
				break;
			case 'yearly':
				this.mode = 'year';
				this.dateClass = 'yearly';
		}
	}

	getCurrencies() {
		this.dashboardSvc.getCurrencyList({ params: this.filter }).subscribe((res) => {
			this.currencies = res['rows'];
		});
	}
	selectedCurr() {
		this.currencies.map((item) => {
			if (item.currencyCode === this.currency) {
				this.currencyId = item.currencyId;
				this.getRegistrationStatis();
			}
		});
	}
	onAll(event) {
		this.showAll = !this.showAll;
		this.getRegistrationStatis();
	}
	getRegisteredUsers() {
		// console.log(this.form.value);
		// this.dashboardSvc
		// 	.getCompanyVerification({
		// 		to: this.form.value.to,
		// 		from: this.form.value.from
		// 	})
		// 	.subscribe((res) => {
		// 		console.log(res);
		// 	});
	}
	changeType(event) {
		switch (event) {
			case 'all':
				this.mode = 'date';
				this.selectedType = 'all';
				this.isAll = !this.isAll;
				this.getRegistrationStatis();
				break;
			case 'day':
				this.mode = 'date';
				this.selectedType = 'day';
				this.isAll = false;
				this.getRegistrationStatis();
				break;
			case 'month':
				this.mode = 'month';
				this.selectedType = 'month';
				this.isAll = false;
				this.getRegistrationStatis();
				break;
			case 'year':
				this.mode = 'year';
				this.selectedType = 'year';
				this.isAll = false;
				this.getRegistrationStatis();
		}
	}
	fromDate(date) {
		if (date) {
			this.fromDateString = new DatePipe('en-US')
				.transform(date.toISOString(), 'dd-MM-yyyy')
				.split('-')
				.reverse()
				.join('-');
			this.getRegistrationStatis();
		}
	}

	toDate(date) {
		if (date) {
			this.toDateString = new DatePipe('en-US')
				.transform(date.toISOString(), 'dd-MM-yyyy')
				.split('-')
				.reverse()
				.join('-');
			this.getRegistrationStatis();
		}
	}

	getRegistrationStatis() {
		this.error = null;
		if (this.fromDateString === '') {
			this.error = 'Please select from date';
		} else if (this.toDateString === '') {
			this.error = 'Please select to date';
		} else {
			if (this.mode == 'year') this.toYear();
			else if (this.mode == 'month') this.toMonth();
			this.pending = true;
			console.log(this.fromDateString)
			this.dashboardSvc
				.getCompanyFinanceRecord({
					body:
						this.isAll
							? {
									customerNccId: this.customerNccId,
									currencyId: this.currencyId
								}
							: {
									from: this.fromDateString,
									to: this.toDateString,
									customerNccId: this.customerNccId,
									currencyId: this.currencyId
								}
				})
				.subscribe(
					(res) => {
						this.pending = false;
						this.invoiceDetail = res;
						// this.format(res);
					},
					(error) => {
						this.pending = false;
						console.log(error);
					}
				);
			// this.registerStatus.emit({ from: this.fromDateString, to: this.toDateString, type: this.selectedType });
		}
	}

	toYear() {
		let fromDate = this.fromDateString.split("-");
		fromDate[1] = "01";
		fromDate[2] = "01";
		this.fromDateString = fromDate.join("-");
		let toDate = this.toDateString.split("-");
		toDate[1] = "01";
		toDate[2] = "01";
		this.toDateString = toDate.join("-");
	}

	toMonth() {
		let fromDate = this.fromDateString.split("-");
		fromDate[2] = "01";
		this.fromDateString = fromDate.join("-");
		let toDate = this.toDateString.split("-");
		if (this.has30Days(toDate[1])) {
			toDate[2] = "30";
		}
		else if (toDate[1] == "02") {
			toDate[2] = "28";
		}
		else {
			toDate[2] = "31";
		}
		this.toDateString = toDate.join("-");
	}

	has30Days(month: string) {
		return ["04", "06", "09", "11"].includes(month);
	}

	ngOnInit(): void {}
}
